module.exports = "https://payments.pagoefectivo-pre.com/Roboto-Regular.18d44f79b3979ec168862093208c6d7d.ttf";